import * as R from 'ramda'
import React from 'react'

import {countriesSeo} from '../../keyrus/static/countries/countriesSeo'

export const createLocalizedAlternateLinks = (siteUrl, slug) =>
  R.concat(
    R.map(e => {
      const {countryCode, localeCode, hrefLang} = e
      const slicedLocale = R.slice(0, 2, localeCode)

      const href =
        countryCode === 'worldwide'
          ? `${siteUrl}/${e.countryCode}/${slug}`
          : `${siteUrl}/${countryCode}/${slicedLocale}/${slug}`

      return <link rel="alternate" hrefLang={hrefLang} href={href} />
    }, countriesSeo),
    [
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${siteUrl}/worldwide/${slug}`}
      />,
    ],
  )
